// extracted by mini-css-extract-plugin
module.exports = {"ImageCard":"ImageCard_ImageCard__3-ihq","imageWrapper":"ImageCard_imageWrapper__1IMpj","Title":"ImageCard_Title__2Xzap"};